module.exports = __webpack_public_path__ + "img/Large-2-Bevel-Attachment-18.7e60e24c.png";